import { createClient } from "@supabase/supabase-js"
import type { Database } from "./database.types"

// Only create client in browser, not during SSR build
const isBrowser = typeof window !== "undefined"

// Initialize the Supabase client with environment variables
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || ""
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || ""

// Ensure environment variables are set (only warn in browser)
if (isBrowser && (!supabaseUrl || !supabaseAnonKey)) {
  console.error(
    "Missing Supabase credentials. Check your environment variables.",
  )
}

// Create client with auto session refresh (browser only, stub during build)
export const supabase = isBrowser
  ? createClient<Database>(supabaseUrl, supabaseAnonKey, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
      },
    })
  : ({} as ReturnType<typeof createClient<Database>>)
